<script setup>
import { computed } from 'vue';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { useSidebar } from './utils';

const props = defineProps({
    class: { type: null, required: false }
});

const { toggleSidebar, state, isMobile, openMobile, open } = useSidebar();

// Determine if sidebar is currently open (mobile or desktop)
const isOpen = computed(() => (isMobile.value ? openMobile.value : open.value));
</script>

<template>
    <Button
        data-sidebar="toggle-button"
        data-slot="sidebar-toggle-button"
        variant="ghost"
        size="icon"
        :class="
            cn(
                'rounded-full w-5.5 h-5.5 p-0 bg-background dark:bg-primary border border-border dark:border-primary/20 shadow-md hover:bg-accent dark:hover:bg-primary/80 hover:shadow-lg transition-all duration-200',
                props.class
            )
        "
        @click="toggleSidebar">
        <ChevronLeft v-if="isOpen" class="h-3 w-3 text-foreground dark:text-primary-foreground" />
        <ChevronRight v-else class="h-3 w-3 text-foreground dark:text-primary-foreground" />
        <span class="sr-only">{{ isOpen ? 'Collapse' : 'Expand' }} Sidebar</span>
    </Button>
</template>
